/*
 * File: /src/router/routes/settings.js
 * Created Date: Friday November 26th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 26th November 2021 9:58:06 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

const UserList = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/UserList.vue'
  );

const UserEdit = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/UserEdit.vue'
  );

const CompanySettings = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/CompanySettings.vue'
  );

const LostReasons = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/LostReasonList.vue'
  );

const AgentKpis = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/AgentKpis.vue'
  );

const ScoringSettings = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/ScoringSettings.vue'
  );

export const settingsRoutes = [
  {
    path: 'settings/users/list',
    name: 'User Settings List',
    component: UserList,
  },
  {
    path: 'settings/users/add',
    name: 'Add User',
    component: UserEdit,
  },
  {
    path: 'settings/users/edit/:id',
    name: 'Edit User',
    component: UserEdit,
  },
  {
    path: 'settings/users',
    redirect: '/admin/settings/users/list',
    name: 'User Settings',
    component: UserList,
  },
  {
    path: 'settings/agent-kpis',
    name: 'Monthly & Agent Goals',
    component: AgentKpis,
  },
  {
    path: 'settings/company',
    name: 'Global Settings',
    component: CompanySettings,
  },
  {
    path: 'settings/lost-reasons',
    name: 'Lost Reasons',
    component: LostReasons,
  },
  {
    path: 'settings/scoring',
    // Distinct from the call-center 'Conversation Scoring' route: vue-router
    // names must be unique, and a collision silently breaks the other one.
    name: 'Scoring Criteria Setup',
    component: ScoringSettings,
  },
  // The criteria and templates screens were merged into one. Kept so existing
  // links and bookmarks land somewhere sensible rather than 404.
  {
    path: 'settings/scoring-criteria',
    redirect: '/admin/settings/scoring',
  },
  {
    path: 'settings/scoring-templates',
    redirect: '/admin/settings/scoring',
  },
];
